import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtosolapurbusonrentpune() {



  const cardData =
  {
    keyword: 'Daund to Solapur Bus On Rent Pune',
    heading: 'Sanavi Travels: Daund to Solapur Bus On Rent Pune',
    headingDescription: 'Sanavi Travels offers reliable Daund to Solapur Bus On Rent Pune, providing safe, comfortable, and convenient transportation for pilgrims, families, corporate groups, and travelers commuting between Daund and Solapur. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate tours, school excursions, and group outings. Choose Sanavi Travels for trusted Daund to Solapur bus rental services from Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Solapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Solapur Siddheshwar Temple",
    "description": "Siddheshwar Temple is one of the most prominent religious sites in Solapur, dedicated to Lord Siddheshwar (Shiva). The temple complex includes a large water tank (Kund) and attracts devotees throughout the year, especially during Maha Shivratri."
  },
  {
    "title": "Solapur Bhuikot Fort",
    "description": "Bhuikot Fort is a historic fort in Solapur, built during the 14th century. It features massive stone walls, bastions, and a unique blend of architectural styles, reflecting the city’s rich historical heritage."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description": "Located near Solapur, Akkalkot Temple is dedicated to Swami Samarth, a revered 19th-century saint. Devotees visit for spiritual guidance, blessings, and to participate in religious ceremonies."
  },
  {
    "title": "Great Indian Bustard Sanctuary",
    "description": "The sanctuary near Solapur is home to the endangered Great Indian Bustard. Birdwatchers and wildlife enthusiasts visit to observe this rare species and the surrounding grassland ecosystem."
  },
  {
    "title": "Chandramouleshwara Temple",
    "description": "Chandramouleshwara Temple is an ancient Shiva temple known for its spiritual significance and beautiful stone carvings. It remains an important center for religious worship and festivals."
  },
  {
    "title": "Solapur Textile Market",
    "description": "Solapur is famous for its textile industry, particularly Solapur chaddars and towels. The textile markets provide a glimpse into local craftsmanship, trade, and traditional weaving techniques."
  },
  {
    "title": "Pandharpur Pilgrimage",
    "description": "Pandharpur, located near Solapur, is a major pilgrimage center dedicated to Lord Vithoba. Many devotees pass through Solapur while traveling to this sacred town, especially during Ashadhi and Kartiki Ekadashi."
  },
  {
    "title": "Solapur Lake",
    "description": "Solapur Lake offers a peaceful environment for relaxation and birdwatching. It is a popular spot for morning walks and enjoying natural scenery within the city."
  },
  {
    "title": "Shivaji Udyan Park",
    "description": "Shivaji Udyan Park is a well-maintained green space in Solapur, perfect for families, joggers, and leisure activities. The park hosts cultural events and provides a recreational retreat in the city."
  },
  {
    "title": "Local Cultural Hubs",
    "description": "Solapur has several cultural centers and community halls where festivals, traditional music, and local arts are celebrated. These hubs reflect the city’s vibrant social and cultural life."
  }
]
,



"services": [
  {
    "name": "Daund to Solapur Bus On Rent Pune",
    "description": "Daund to Solapur Bus On Rent Pune provides comfortable and reliable bus services for large groups traveling between Daund and Solapur. Equipped with air-conditioned interiors, spacious seating, and professional chauffeurs, the service ensures safe, timely, and smooth journeys. Ideal for family trips, corporate outings, group tours, school excursions, or religious travel, this bus service emphasizes convenience, comfort, and efficiency for long-distance travel."
  },
  {
    "name": "Solapur Bus Hire from Daund",
    "description": "Solapur Bus Hire from Daund offers flexible and affordable bus rental options for groups traveling to Solapur. With AC interiors, ample seating, and experienced drivers, it ensures a comfortable and hassle-free journey. Perfect for family trips, corporate travel, sightseeing, or religious tours, this service guarantees punctuality and safety on every trip."
  },
  {
    "name": "AC Bus Daund to Solapur",
    "description": "AC Bus Daund to Solapur provides a cool and relaxing travel experience for long-distance journeys. Equipped with air-conditioning, comfortable seating, and professional chauffeurs, it ensures smooth and enjoyable travel for families, corporate groups, tourists, and school trips traveling between Daund and Solapur."
  },
  {
    "name": "Luxury Bus Solapur Trip",
    "description": "Luxury Bus Solapur Trip offers premium travel for groups seeking comfort, style, and convenience. With plush AC seating, spacious interiors, and professional drivers, it is perfect for VIP travel, weddings, corporate outings, and special events, ensuring timely arrivals and a memorable journey to Solapur."
  },
  {
    "name": "Family Bus Solapur",
    "description": "Family Bus Solapur provides safe and comfortable transport for families traveling together to Solapur. With air-conditioned interiors, spacious seating, luggage space, and professional chauffeurs, it ensures a relaxed and enjoyable journey suitable for family vacations, reunions, and weekend getaways."
  },
  {
    "name": "Group Travel Bus Solapur",
    "description": "Group Travel Bus Solapur caters to friends, corporate teams, school groups, or tour groups traveling together. With AC interiors, ample seating, and skilled drivers, it provides organized, comfortable, and safe transport, making long-distance group travel convenient and stress-free."
  },
  {
    "name": "Affordable Bus Solapur",
    "description": "Affordable Bus Solapur provides cost-effective transport solutions without compromising on safety or comfort. Perfect for budget-conscious travelers, school trips, corporate groups, or social tours, the bus comes equipped with AC, spacious seating, and professional chauffeurs for a reliable and smooth journey."
  },
  {
    "name": "Chauffeur Driven Bus Solapur",
    "description": "Chauffeur Driven Bus Solapur offers a hassle-free travel experience with experienced drivers managing navigation, traffic, and passenger safety. Ideal for corporate outings, family trips, group tours, and religious journeys, this service ensures a smooth and comfortable travel experience."
  },
  {
    "name": "Best Bus Daund to Solapur",
    "description": "Best Bus Daund to Solapur focuses on delivering top-quality transport services with well-maintained AC buses, spacious seating, and skilled chauffeurs. Suitable for weddings, corporate events, family trips, school excursions, and long-distance travel, it ensures a safe, punctual, and enjoyable journey."
  },
  {
    "name": "Tourist Bus Solapur",
    "description": "Tourist Bus Solapur is designed for sightseeing, leisure trips, and exploration tours. With comfortable AC seating, luggage space, and professional chauffeurs, it ensures travelers enjoy a safe and convenient journey while visiting tourist attractions in and around Solapur."
  },
  {
    "name": "Outstation Bus Daund",
    "description": "Outstation Bus Daund provides long-distance travel solutions for groups heading to Solapur or other destinations. AC interiors, spacious seating, and skilled drivers guarantee a smooth, safe, and enjoyable journey for families, friends, corporate teams, and school trips."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows customers to easily reserve buses for Daund to Solapur trips through a convenient online platform. Instant booking confirmation, flexible scheduling, and hassle-free management ensure smooth travel planning for families, corporate teams, and group tours."
  },
  {
    "name": "Event Bus Solapur",
    "description": "Event Bus Solapur offers specialized bus services for weddings, corporate events, school functions, and other gatherings. With AC interiors, ample seating, and professional chauffeurs, it ensures comfortable, timely, and organized transport for all passengers attending events in Solapur."
  },
  {
    "name": "Daund Solapur Travel Bus",
    "description": "Daund Solapur Travel Bus provides reliable, comfortable, and safe transportation for long-distance journeys between Daund and Solapur. Suitable for families, corporate groups, tourists, and school trips, the service includes AC interiors, spacious seating, luggage space, and professional chauffeurs for a stress-free travel experience."
  },
  {
    "name": "Long Distance Bus Pune",
    "description": "Long Distance Bus Pune offers dependable transport for travelers covering Daund to Solapur and other long routes. With air-conditioned buses, professional drivers, and well-maintained seating, it ensures comfort, safety, and timely arrivals for all passengers on extended journeys."
  }
],
"tableData": [
  ["Daund to Solapur Bus On Rent Pune", "Solapur Bus Hire from Daund"],
  ["AC Bus Daund to Solapur", "Luxury Bus Solapur Trip"],
  ["Family Bus Solapur", "Group Travel Bus Solapur"],
  ["Affordable Bus Solapur", "Chauffeur Driven Bus Solapur"],
  ["Best Bus Daund to Solapur", "Tourist Bus Solapur"],
  ["Outstation Bus Daund", "Online Bus Booking Daund"],
  ["Event Bus Solapur", "Daund Solapur Travel Bus"],
  ["Long Distance Bus Pune", "—"]
]
,




"whychoose": [
  {
    "WhyChooseheading": "Daund to Solapur Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable bus rental services from Daund to Solapur, perfect for family trips, pilgrimages, group tours, corporate travel, and long‑distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced buses that ensure a smooth and enjoyable journey from Daund to Solapur."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Solapur route, ensuring safe and timely travel throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront and clear pricing for Daund to Solapur bus rentals, inclusive of fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route updates, travel queries, and itinerary planning for your Daund to Solapur trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized bus rental packages based on your Daund to Solapur travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Solapur bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rentals from Daund to Solapur?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services from Daund to Solapur for long‑distance travel.'
  },
  {
    question: 'How can I book a Daund to Solapur bus rental?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the Daund to Solapur route?',
    answer: 'Sanavi Travels provides air‑conditioned and well‑maintained buses suitable for long‑distance travel from Daund to Solapur.'
  },
  {
    question: 'Are drivers experienced on the Daund to Solapur route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the entire Daund to Solapur journey.'
  },
  {
    question: 'Can I customize my Daund to Solapur travel itinerary?',
    answer: 'Absolutely. You can select preferred stops, routes, and travel duration based on your trip requirements.'
  },
  {
    question: 'Is the bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock support and assistance throughout your Daund to Solapur trip.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Solapur bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Patil',
    feedback: 'Booked a bus from Daund to Solapur. Comfortable ride, professional driver, and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great experience with the Daund to Solapur bus rental. Clean bus and excellent customer support.',
    rating: 5
  }
];



























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Solapur Bus On Rent Pune - Sanavi Travels",
  "description": "Sanavi Travels offers Daund to Solapur bus rental from Pune for family trips, group travel, corporate events, and outstation tours. AC and luxury chauffeur-driven buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "85"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Daund to Solapur Bus On Rent Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Daund to Solapur bus from Pune with Sanavi Travels for family trips, group travel, corporate events, and outstation tours. AC and luxury chauffeur-driven buses available. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/111.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtosolapurbusonrentpune;